import { ReactNode } from "react";
import iBtnArrow from "../../../assets/icons/btn-arrow.svg";
import "./button.sass";

type Props = {
  children?: ReactNode;
  onClick?: () => void;
  className?: string;
};

const Button = ({ children, onClick, className }: Props) => {
  return (
    <div className={`button ${className ? className : ""}`} onClick={onClick}>
      <div className="button__text">{children}</div>

      <img
        src={iBtnArrow}
        className="services-block-content-item__button-arrow"
        alt=""
      />
    </div>
  );
};

export default Button;
